const API_URL = process.env.REACT_APP_API_URL + "/api";

/**
 * Fetch recent activity from the backend
 * @returns {Promise} Recent activity data
 */
export const fetchRecentActivity = async () => {
  const apiUrl = `${API_URL}/admin/recent-activity`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });

  if (!response.ok) {
    let error = await response.json();
    throw new Error(error.message || 'Failed to fetch recent activity');
  }

  return response.json();
};

/**
 * Fetch upcoming events with optional filters
 * @param {Object} filters - Filter parameters
 * @param {string} filters.search - Search query for event name/location
 * @param {string} filters.category - Category filter (all/livestream/production)
 * @param {string} filters.status - Status filter (all/active/pending)
 * @param {string} filters.date - Date filter (ISO string)
 * @returns {Promise} Upcoming events data
 */
export const fetchUpcomingEvents = async (filters = {}) => {
  const queryParams = new URLSearchParams();

  // Build query parameters from filters
  if (filters.search && filters.search.trim()) {
    queryParams.append('search', filters.search.trim());
  }
  if (filters.category && filters.category !== 'all') {
    queryParams.append('event_type', filters.category);
  }
  if (filters.status && filters.status !== 'all') {
    queryParams.append('status', filters.status);
  }
  if (filters.date) {
    queryParams.append('date', filters.date);
  }

  const queryString = queryParams.toString();
  const apiUrl = `${API_URL}/admin/get-projects${queryString ? `?${queryString}` : ''}`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });

  if (!response.ok) {
    let error = await response.json();
    throw new Error(error.message || 'Failed to fetch upcoming events');
  }

  return response.json();
};

/**
 * Fetch project statistics for the dashboard map legend
 * @returns {Promise} Project stats data
 */
export const fetchProjectStats = async () => {
  const apiUrl = `${API_URL}/admin/get-project-status`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });

  if (!response.ok) {
    let error = await response.json();
    throw new Error(error.message || 'Failed to fetch project stats');
  }

  return response.json();
};
